import React from 'react';
import PropTypes from 'prop-types';
import { Carousel, Container, StarRating, ReviewCard } from '@pella/sash-framework';
import { useGlobalConfig } from '../../../hooks/use-global-config';
import { CTA } from '../..';
import { isValidArray } from '../../utilities/validations';

const ReviewsSlider = ({ title, reviews, cta, className, ...other }) => {
	const { reviews: configData } = useGlobalConfig();
	if (!isValidArray(reviews?.Reviews)) return null;

	return (
		<div
			className={`branchReviews overflow-hidden py-6 md:py-8 xl:py-12 ${className || ''}`}
			data-silktide='ignore'
			{...other}
		>
			<Container>
				{title && (
					<h2
						className='mb-3 font-semibold'
						dangerouslySetInnerHTML={{ __html: title }}
					/>
				)}

				<div className='mb-6 flex items-center'>
					{reviews?.OverallSatisfactionRating && (
						<StarRating
							rating={+reviews?.OverallSatisfactionRating}
							className='branch-starRatings mr-3'
							hideRating
						/>
					)}
					{cta?.[0] && (
						<CTA
							className='mt-0.5 !w-auto md:mt-1'
							data={cta[0]}
						/>
					)}
				</div>
			</Container>

			<Container noPadding>
				<Carousel
					className='branchReviews-slider'
					slidePadding={16}
					showSlideHints
					showArrows
				>
					{reviews.Reviews.slice(0, 3).map((review, index) => {
						const date = new Date(review.DateSurveyed);

						return (
							<ReviewCard
								rating={+review.OverallSatisfactionRating}
								date={date?.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
								key={index}
							>
								{review.WhyChosePella && (
									<>
										<ReviewCard.Heading content={configData?.heading_1} />
										<ReviewCard.Content content={review.WhyChosePella} />
									</>
								)}
								{review.MemorableAspects && (
									<>
										<ReviewCard.Heading content={configData?.heading_2} />
										<ReviewCard.Content content={review.MemorableAspects} />
									</>
								)}
								<ReviewCard.Author name={review.CustomerFirstName + ' ' + review.CustomerLastName} />
							</ReviewCard>
						);
					})}

					{configData && cta?.[0] && (
						<ReviewCard className='branch-allReviewsCard'>
							{configData?.heading && <ReviewCard.Heading content={configData?.heading} />}
							{configData?.description && <ReviewCard.Content content={configData?.description} />}

							{cta?.[0] && (
								<CTA
									size='sm'
									data={{ ...cta[0], button_style: 'primary' }}
								/>
							)}
						</ReviewCard>
					)}
				</Carousel>
			</Container>
		</div>
	);
};

ReviewsSlider.propTypes = {
	title: PropTypes.string,
	reviews: PropTypes.object,
	cta: PropTypes.array,
	children: PropTypes.node,
	className: PropTypes.string,
};

export default ReviewsSlider;
